// Minimal hard-coded place labels per region — just enough landmarks for
// orientation. Designer chose to keep this sparse, not a POI dump.

export interface PlaceLabel {
  lat: number;
  lng: number;
  /** Display name (全形空格 separated as designed) */
  zh: string;
  /** 0..1 visual weight; >= 0.95 reads as primary */
  weight: number;
}

export const PLACE_LABELS: Record<string, PlaceLabel[]> = {
  ruifang: [
    { lat: 25.1087, lng: 121.80733, zh: "瑞 芳 車 站", weight: 1 },
    { lat: 25.1056, lng: 121.8102, zh: "瑞 芳 老 街", weight: 0.85 },
    { lat: 25.1105, lng: 121.8097, zh: "基 隆 河", weight: 0.7 },
  ],
  sandiaoling: [
    { lat: 25.0661, lng: 121.8224, zh: "三 貂 嶺 車 站", weight: 1 },
    { lat: 25.0645, lng: 121.82317, zh: "三 貂 嶺 生 態 隧 道", weight: 0.85 },
  ],
  ruibin: [
    { lat: 25.1351, lng: 121.8203, zh: "瑞 濱 海 岸", weight: 1 },
  ],
  daping: [
    { lat: 25.1294, lng: 121.8595, zh: "大 坪", weight: 1 },
  ],
};
